function formatCurrency(number:number) {
    if (typeof number !== 'number' || isNaN(number)|| Number(number) === 0) {
        return '';
      }
     
    // 将数字转换为字符串
    let numStr = String(number);
     
    // 分离整数部分和小数部分
    let parts = numStr.split('.');
    let integerPart = parts[0];
    let decimalPart = parts.length > 1 ? '.' + parts[1] : '';
  
    // 使用正则表达式添加千位分隔符
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  
    // 组合整数部分和小数部分
    return integerPart + decimalPart;
  }
  export default formatCurrency